export default __webpack_public_path__ + "static/media/wSkirt_1_c1.5c8dc533.jpeg";